import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { IFetchTasksResult } from "./types";
import { serverResponse, TaskType } from "./validators";

interface IFetchTasksProps {
  type: TaskType;
  userId?: string;
}

export async function fetchTasks({
  type,
  userId,
}: IFetchTasksProps): Promise<IFetchTasksResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/tasks`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
        "accept-language": "pl",
      },
      searchParams: {
        type,
        ...(userId && { userId }),
      },
      validator: serverResponse,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
